import axios, { type AxiosResponse } from "axios";
import { baseUrl } from "./constants";

// Request type
export interface SetFavoriteChatSessionRequest {
  is_favorite: boolean;
}

// Response type
export interface SetFavoriteChatSessionResponse {
  success: boolean;
  message: string;
  is_favorite: boolean;
}

// Axios PATCH request
export function setChatSessionFavorite(
  chat_session_uid: string,
  data: SetFavoriteChatSessionRequest,
): Promise<AxiosResponse<SetFavoriteChatSessionResponse>> {
  return axios.patch<SetFavoriteChatSessionResponse>(
    `${baseUrl}/api/v1/quotation-request-chat/session/${chat_session_uid}/favorite`,
    data,
  );
}
